import { Suspense } from "react";
import { Outlet } from "react-router";
import { SkipLink } from "@/components/a11y";
import { PageSkeleton } from "@/components/ui/page-skeleton";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useDocumentTitle, useFocusOnRouteChange } from "@/hooks";
import { AppHeader } from "./app-header";
import { AppSidebar } from "./app-sidebar";

export function AppLayout() {
	useDocumentTitle();
	useFocusOnRouteChange();

	return (
		<>
			<SkipLink />
			<SidebarProvider>
				<AppSidebar />
				<SidebarInset>
					<AppHeader />
					<main
						id="main-content"
						tabIndex={-1}
						className="flex-1 p-4 md:p-6"
						data-testid="main-content"
					>
						<Suspense fallback={<PageSkeleton />}>
							<Outlet />
						</Suspense>
					</main>
				</SidebarInset>
			</SidebarProvider>
		</>
	);
}
